import 'slick-carousel';

import {
	mobileMenuSliderSetting,
	headerShowSliderSetting,
	postModuleSliderSetting,
	exclusiveModuleSliderSetting
} from './_slider-setting';

var $headerNavigationSlider, $headerNavigationMobileSlider, $postSlider, $exclusiveSlider;


const initSliders = function () {
	setHeaderSliders();
	setModuleSlickSliders();
};

const setHeaderSliders = function () {
	$headerNavigationSlider = $(
		'.ren-header-topnav .ren-header-slider__slider'
	);
	$headerNavigationMobileSlider = $(
		'.ren-mobnav .ren-header-slider__slider'
	);
};

const setModuleSlickSliders = function () {
	$postSlider = $('.ren-posts-slider__list');
	$exclusiveSlider = $('.ren-exclusive-slider');
};


const initHeaderSlider = function () {
	$headerNavigationSlider.slick(headerShowSliderSetting);
	$headerNavigationMobileSlider.slick(mobileMenuSliderSetting);
};

const initModuleSlickSlider = function () {
	// Slider counter (1 of 12)
	$postSlider
		.add($exclusiveSlider)
		.on(
			'init reInit afterChange',
			function (event, slick, currentSlide) {
				//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
				if (!slick.slideCount) {
					return;
				}
				const i = (currentSlide ? currentSlide : 0) + 1;
				if ($(this).next().hasClass('slider-counter')) {
					const $counter = $(this).next();
					$counter.text(i + ' of ' + slick.slideCount);
				}
			}
		);

	$postSlider.slick(postModuleSliderSetting);

	if (window.matchMedia('(max-width: 800px)').matches) {
		$exclusiveSlider.slick(exclusiveModuleSliderSetting);
		console.log('slick');

	}
};

const disableModuleSlickSlider = function () {
	if ($exclusiveSlider.hasClass('slick-initialized')) {
		$exclusiveSlider.slick('unslick');
	}
	if ($postSlider.hasClass('slick-initialized')) {
		$postSlider.slick('unslick');
	}
};

export {
	$headerNavigationMobileSlider,
	disableModuleSlickSlider,
	initHeaderSlider,
	initModuleSlickSlider,
	initSliders,
	setModuleSlickSliders
};
